import { ConversationScreen } from 'component/screen';
import { UtilityText } from 'component/text';
import { component, demoFile } from 'system/demo';

demoFile('component/screen');

function ConversationScreenDemo() {
    return (
        <ConversationScreen pad>
            <UtilityText text='Content inside conversation screen' />
        </ConversationScreen>
    );
}

component('ConversationScreen', ConversationScreenDemo);
